import ColorThief from 'colorthief';
// Enhanced GSAP Animation Setup for Multiple Dropdowns
document.addEventListener('DOMContentLoaded', function () {
  const colorThief = new ColorThief();
  const banner = document.querySelectorAll('.thief-banner');

  banner.forEach((bannerElement) => {
    const img = bannerElement.querySelector(
      '.thief-banner img'
    ) as HTMLImageElement;
    if (img && banner) {
      // Ensure the image is fully loaded
      if (img.complete) {
        applyColor(bannerElement as HTMLElement, img);
      } else {
        img.addEventListener('load', () => {
          applyColor(bannerElement as HTMLElement, img);
        });
      }
    }
  });

  function applyColor(banner: HTMLElement, img: HTMLImageElement) {
    try {
      const dominantColor = colorThief.getColor(img);
      const rgbString = `rgba(${dominantColor[0]}, ${dominantColor[1]}, ${dominantColor[2]}, 0.13)`;
      banner.style.backgroundColor = rgbString;
    } catch (error) {
      console.error('Error extracting color:', error);
    }
  }
});
